<template>
  <v-container>
    <div class="custom-class" style="display: flex; gap: 20px">
      <v-card
        class="mx-auto bg-white lighten-1 pad-to-add-coup"
        style="max-width: 850px; min-width: 200px; width: 100%"
      >
        <v-card-title class="pb-2 pl-0 font-weight-bold">General</v-card-title>
        <v-card-text>
          <v-form ref="couponForm" v-model="valid">
            <!-- Title Field -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="title">Title<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="coupon.design.title"
                  density="compact"
                  required
                  :counter="30"
                  :maxlength="30"
                  :rules="[rules.required, rules.maxLength(30)]"
                  label="Title"
                  data-testid="editcoupon-title"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Description Field -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="description">Description<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Description"
                  v-model="coupon.design.description"
                  :counter="70"
                  :maxlength="70"
                  :rules="[rules.required, rules.maxLength(70)]"
                  rows="1"
                  density="compact"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Disclaimer Field -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="disclaimer">Disclaimer<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Disclaimer"
                  v-model="coupon.design.disclaimer"
                  :counter="100"
                  :maxlength="100"
                  :rules="[rules.required, rules.maxLength(100)]"
                  rows="1"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Link Label Field -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="linkLabel">Link Label:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Link Label"
                  v-model="coupon.callToAction.text"
                  :counter="50"
                  :maxlength="50"
                  :rules="[rules.maxLength(50)]"
                  density="compact"
                  placeholder="e.g., Shop Now, Learn More"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Link URL Field -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="link">Link URL:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Link URL"
                  v-model="coupon.callToAction.link"
                  :rules="[rules.url]"
                  density="compact"
                  placeholder="https://example.com or /relative/path"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Start Time Field -->
            <v-row>
              <v-col cols="10" sm="4">
                <label for="start-time">Start Time<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8" class="mb-4">
                <v-text-field
                  type="datetime-local"
                  v-model="coupon.startTime"
                  @change="StatusChange"
                  density="compact"
                  outlined
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>

            <!-- End Time Field -->
            <v-row>
              <v-col cols="10" sm="4">
                <label for="start-time">End Time<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8" class="mb-4">
                <!-- <div class="datepicker-wrapper">
                  <flat-pickr v-model="coupon.endTime" :config="config" class="custom-datepicker"
                    placeholder="mm/dd/yyyy --:-- --" @change="EndStatusChange" />
                  <v-icon class="calendar-icon">mdi-calendar</v-icon>
                </div> -->
                <!-- <div class="mobile-only">
                  <v-text-field v-model="coupon.endTime" type="datetime-local" dense outlined
                    @change="EndStatusChange" />
                </div> -->
                <v-text-field
                  type="datetime-local"
                  v-model="coupon.endTime"
                  @change="EndStatusChange"
                  density="compact"
                  outlined
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>

            <!-- Usage Limit -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="Usage Limit">Usage Limit<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Usage Limit"
                  v-model="coupon.usageLimit"
                  :min="0"
                  type="number"
                  required
                  outlined
                  :rules="[rules.required, rules.positiveNumber]"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Minimum Purchase Amount -->
            <!-- Minimum Purchase Amount -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="Minimum Purchase Amount"
                  >Minimum Purchase Amount<span>*</span>:</label
                >
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Minimum Purchase Amount"
                  v-model="coupon.minPurchaseAmount"
                  :min="0"
                  type="number"
                  required
                  outlined
                  :rules="[rules.required, rules.positiveNumber]"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Discount Type -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="Discount Type">Discount Type<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-select
                  id="discount-type"
                  v-model="coupon.discountType"
                  :items="discountOptoins"
                  label="Discount Type"
                  density="compact"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Status Field -->
            <v-row class="mb-4">
              <v-col cols="10" sm="4">
                <label for="status">Status<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-select
                  id="status"
                  v-model="coupon.status"
                  :items="statusOptions"
                  item-value="value"
                  item-title="title"
                  density="compact"
                  ref="statusSelect"
                  @update:modelValue="reasonDialog"
                  data-testid="editcoupon-status"
                />
              </v-col>
            </v-row>

            <v-row
              class="mb-4"
              v-if="['Draft', 'Archived', 'Paused'].includes(coupon.status)"
            >
              <v-col cols="10" sm="4">
                <label for="reason">Reason:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-textarea
                  id="reason"
                  v-model="coupon.reason"
                  density="compact"
                  rows="3"
                  placeholder="Reason for the current status"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="!coupon.parentCouponId" align="center" class="mb-4">
              <v-col cols="10" sm="4">
                <label for="recurring" class="form-label">Recurring:</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-checkbox
                  id="recurring"
                  v-model="coupon.isRecurring"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row v-if="coupon.isRecurring" class="mb-4">
              <v-col cols="10" sm="4">
                <label for="recurringType">Recurring Type</label>
              </v-col>
              <v-col cols="12" sm="8">
                <v-select
                  id="recurringType"
                  v-model="coupon.recurringType"
                  :items="recurringOption"
                  label="Recurring Type"
                  density="compact"
                  @change="onStatusChange"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="dateErrorMessage" class="mb-4">
              <v-col cols="10" sm="12">
                <v-alert type="error" :value="true">{{
                  dateErrorMessage
                }}</v-alert>
              </v-col>
            </v-row>

            <!-- Dynamic Input Fields -->

            <v-card-title class="pb-2 pl-0 font-weight-bold"
              >Media
              <span
                style="
                  color: gray;
                  font-family: 400 !important;
                  font-size: 16px;
                "
              ></span
            ></v-card-title>
            <!-- Media Fields -->

            <v-row class="mb-4">
              <v-col cols="12" sm="3">
                <label for="logo">Logo<span>*</span>:</label>
              </v-col>
              <v-col cols="12" sm="9">
                <div
                  ref="dropzoneLogo"
                  class="dropzone"
                  v-tooltip.top="'Max file-size 2 MB'"
                  data-testid="editcoupon-logo-dropzone"
                ></div>
                <div
                  v-if="isFileSizeError"
                  class="error-message"
                  style="color: red; font-size: 14px"
                >
                  File size cannot exceed 2 MB.
                </div>
              </v-col>
            </v-row>

            <!-- <v-row class="mb-4">
            <v-col cols="12" sm="1"></v-col>
            <v-col cols="12" sm="2">
              <label for="image">Image:</label>
            </v-col>
            <v-col cols="12" sm="8">
              <div ref="dropzoneCouponImage" class="dropzone"></div>
            </v-col>
          </v-row> -->

            <!-- <v-row class="mb-4">
            <v-col cols="12" sm="1"></v-col>
            <v-col cols="12" sm="2">
              <label for="thumbnail">Thumbnail:</label>
            </v-col>
            <v-col cols="12" sm="8">
              <div ref="dropzoneThumbnail" class="dropzone"></div>
            </v-col>
          </v-row> -->

            <br />

            <v-card-title class="pb-2 pl-0 font-weight-bold"
              >Title Typography</v-card-title
            >

            <v-row>
              <!-- Title Field -->
              <v-col cols="10"> </v-col>

              <!-- Font Weight & Style Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.fontWeight"
                  :items="fontWeights"
                  density="compact"
                  label="Font Weight"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Align Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.textAlign"
                  :items="textAlignOptions"
                  density="compact"
                  label="Text Align"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Transform Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.textTransform"
                  :items="textTransformOptions"
                  density="compact"
                  label="Text Transform"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Decoration Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.textDecoration"
                  :items="textDecorationOptions"
                  density="compact"
                  label="Text Decoration"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Font Size Field -->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="coupon.typography.title.fontSize"
                  label="Font Size (px)"
                  density="compact"
                  type="number"
                  required
                ></v-text-field>
              </v-col>

              <!-- Line Height Field -->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="coupon.typography.title.lineHeight"
                  label="Line Height (em)"
                  density="compact"
                  type="number"
                  required
                ></v-text-field>
              </v-col>

              <!-- Height Field -->
              <!-- <v-col cols="12" sm="6">
              <v-text-field
                v-model="coupon.height"
                label="Height (px)"
                type="number"
                density="compact"
                required
              ></v-text-field>
            </v-col> -->

              <!-- Font Color Field -->
              <v-col cols="12" sm="6">
                <v-color-picker
                  v-model="coupon.typography.title.fontColor"
                  label="Font Color"
                  density="compact"
                ></v-color-picker>
              </v-col>
            </v-row>
            <br />
            <br />

            <v-card-title class="pb-2 pl-0 font-weight-bold"
              >Description Typography</v-card-title
            >

            <v-row>
              <!-- Title Field -->
              <v-col cols="10"> </v-col>

              <!-- Font Weight & Style Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.descriptionfontWeight"
                  :items="fontWeights"
                  density="compact"
                  label="Font Weight"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Align Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.descriptiontextAlign"
                  :items="textAlignOptions"
                  density="compact"
                  label="Text Align"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Transform Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.descriptiontextTransform"
                  :items="textTransformOptions"
                  density="compact"
                  label="Text Transform"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Decoration Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.descriptiontextDecoration"
                  :items="textDecorationOptions"
                  density="compact"
                  label="Text Decoration"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Font Size Field -->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="coupon.typography.title.descriptionfontSize"
                  label="Font Size (px)"
                  density="compact"
                  type="number"
                  required
                ></v-text-field>
              </v-col>

              <!-- Line Height Field -->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="coupon.typography.title.descriptionlineHeight"
                  label="Line Height (em)"
                  density="compact"
                  type="number"
                  required
                ></v-text-field>
              </v-col>

              <!-- Height Field -->
              <!-- <v-col cols="12" sm="6">
              <v-text-field
                v-model="coupon.height"
                label="Height (px)"
                type="number"
                density="compact"
                required
              ></v-text-field>
            </v-col> -->

              <!-- Font Color Field -->
              <v-col cols="12" sm="6">
                <v-color-picker
                  v-model="coupon.typography.title.descriptionfontColor"
                  label="Font Color"
                  density="compact"
                ></v-color-picker>
              </v-col>
            </v-row>
            <br />
            <br />

            <v-card-title class="pb-2 pl-0 font-weight-bold"
              >Disclaimer Typography</v-card-title
            >

            <v-row>
              <!-- Title Field -->
              <v-col cols="12"> </v-col>

              <!-- Font Weight & Style Field -->
              <v-col cols="10" sm="6">
                <v-select
                  v-model="coupon.typography.title.disclaimerfontWeight"
                  :items="fontWeights"
                  density="compact"
                  label="Font Weight"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Align Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.disclaimertextAlign"
                  :items="textAlignOptions"
                  density="compact"
                  label="Text Align"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Transform Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.disclaimertextTransform"
                  :items="textTransformOptions"
                  density="compact"
                  label="Text Transform"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Text Decoration Field -->
              <v-col cols="12" sm="6">
                <v-select
                  v-model="coupon.typography.title.disclaimertextDecoration"
                  :items="textDecorationOptions"
                  density="compact"
                  label="Text Decoration"
                  item-value="value"
                  item-title="text"
                  required
                />
              </v-col>

              <!-- Font Size Field -->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="coupon.typography.title.disclaimerfontSize"
                  label="Font Size (px)"
                  density="compact"
                  type="number"
                  required
                ></v-text-field>
              </v-col>

              <!-- Line Height Field -->
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="coupon.typography.title.disclaimerlineHeight"
                  label="Line Height (em)"
                  density="compact"
                  type="number"
                  required
                ></v-text-field>
              </v-col>

              <!-- Height Field -->
              <!-- <v-col cols="12" sm="6">
              <v-text-field
                v-model="coupon.height"
                label="Height (px)"
                type="number"
                density="compact"
                required
              ></v-text-field>
            </v-col> -->

              <!-- Font Color Field -->
              <v-col cols="12" sm="6">
                <v-color-picker
                  v-model="coupon.typography.title.disclaimerfontColor"
                  label="Font Color"
                  density="compact"
                ></v-color-picker>
              </v-col>
            </v-row>
            <br />
            <br />

            <v-row justify="end">
              <div
                class="d-flex updated-content justify-content-end auto-width style-div-button"
              >
                <v-btn color="red" @click="openDeleteDialog" text="Delete" />
                <v-btn
                  color="primary"
                  @click="updateCoupon"
                  text="Update Coupon"
                  :loading="loading"
                  :disabled="!valid"
                />
                <v-btn
                  outlined
                  color="black"
                  class="cancel-btn"
                  text="Cancel"
                  @click="cancel"
                />
              </div>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
      <v-card
        style="max-width: 450px; width: 100%; padding: 20px"
        class="sticky-preview"
      >
        <article
          role="article"
          class="coupon-card"
          aria-labelledby="coupon.title"
          :id="`coupon-${coupon.couponId}`"
        >
          <v-img
            :src="coupon.design.media?.logo"
            alt="Card image"
            height="150px"
            class="mb-2"
            aria-label="Coupon image"
            style="
              aspect-ratio: 16/16;
              object-fit: contain;
              background: #f5f5f5;
            "
          ></v-img>

          <h2
            class="coupon-title d-flex mt-2"
            :id="`coupon-title-${coupon.couponId}`"
            aria-describedby="coupon-description-{{ coupon.couponId }} coupon-disclaimer-{{ coupon.couponId }} coupon-expiration-{{ coupon.couponId }}"
          >
            {{}}
            <span
              class="color-field"
              :style="{
                fontSize: Style(coupon).fontSize,
                lineHeight: Style(coupon).lineHeight,
              }"
              >Title:
            </span>
            <div
              class="title-text"
              :style="Style(coupon)"
              style="width: 100%; margin-left: 2px"
            >
              {{ coupon?.design?.title }}
            </div>
          </h2>
          <!-- <v-row
            class="my-3"
            justify="space-between"
            :style="{ textAlign: coupon.textAlign }"
            role="presentation"
          >
            <v-col
              cols="4"
              v-for="(listItem, listIdx) in coupon.listItems"
              :key="listIdx"
              class="text-start"
              role="list"
              aria-labelledby="listIdx"
            >
              <div
                v-for="(item, itemIdx) in listItem.items"
                :key="itemIdx"
                class="list-items"
                :style="Style(coupon)"
                role="listitem"
              >
                • {{ item }}
              </div>
            </v-col>
          </v-row> -->
          <div
            class="coupon-description d-flex text--secondary mt-3"
            :class="{ expanded: coupon.isDescriptionExpanded }"
            :id="`coupon-description-${coupon.couponId}`"
          >
            <span
              class="color-field"
              :style="{
                fontSize: descriptionStyle(coupon).fontSize,
                lineHeight: descriptionStyle(coupon).lineHeight,
              }"
            >
              Description:
            </span>
            <div
              class="title-text"
              style="width: 100%; margin-left: 2px"
              :style="descriptionStyle(coupon)"
            >
              {{ coupon?.design?.description }}
            </div>
          </div>
          <div style="border-top: 1px solid #ede6e6" class="mt-3"></div>

          <div class="disclaimer d-flex mt-3" id="coupon.disclaimer">
            <span
              class="color-field"
              :style="{
                fontSize: disclaimerStyle(coupon).fontSize,
                lineHeight: disclaimerStyle(coupon).lineHeight,
              }"
            >
              Disclaimer:
            </span>
            <div
              class="title-text"
              :style="disclaimerStyle(coupon)"
              style="width: 100%; margin-left: 2px"
            >
              {{ coupon?.design?.disclaimer }}
            </div>
          </div>
          <div class="exp-info mt-3">
            <span class="color-field">Expiration Date: </span
            >{{ calculateExpirationInfo(coupon?.endTime) }}
          </div>

          <!-- Link Section -->
          <div
            v-if="coupon.callToAction?.link && coupon.callToAction?.text"
            class="mt-3"
          >
            <a
              :href="coupon.callToAction.link"
              target="_blank"
              rel="noopener noreferrer"
              class="coupon-link"
              style="
                display: inline-block;
                padding: 8px 16px;
                background-color: #007bff;
                color: white;
                text-decoration: none;
                border-radius: 4px;
                font-weight: 500;
              "
            >
              {{ coupon.callToAction.text }}
            </a>
          </div>
        </article>
      </v-card>
    </div>
  </v-container>

  <!-- Delete Confirmation Dialog -->
  <v-dialog v-model="deleteDialog.visible" width="auto" height="auto">
    <v-card>
      <v-card-title> Delete Coupon </v-card-title>
      <v-card-text> Are you sure you want to delete this coupon? </v-card-text>
      <v-card-actions>
        <v-btn @click="deleteDialog.visible = false" text="Cancel" />
        <v-btn color="red" @click="confirmDelete" text="Delete" />
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar v-model="snackbar.visible" :timeout="3000" color="success" top>
    {{ snackbar.message }}
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref, reactive, watch, computed, nextTick, onUnmounted } from 'vue'
import { useCounterStore } from '@/stores/counter'
// import { useRoute, useRouter } from 'vue-router'
import 'flatpickr/dist/flatpickr.css'
import 'dropzone/dist/dropzone.css'
import { useToast } from 'vue-toastification'
import { convertLocalTimeToServerTime } from '@/utils'
import Dropzone from 'dropzone'
import type { FullCoupon, CouponPayload } from '@/interface/Coupon'

const props = defineProps<{
  couponId: string
}>()

const emit = defineEmits<{
  'update:couponId': [couponId: string | null]
}>()

const selectedCouponId = ref(props.couponId || '')

// Composables
const store = useCounterStore()
// const route = useRoute()
// const router = useRouter()
const toast = useToast()

// Reactive state
const couponData = ref(null)
const dateFormat = ref(null)
const isFileSizeError = ref(false)
const dropzoneLogo = ref<HTMLElement | null>(null)
const dropzoneCouponImage = ref<HTMLElement | null>(null)
const dropzoneThumbnail = ref<HTMLElement | null>(null)
const originalCoupon = ref<FullCoupon | null>(null)
const couponIdToShow = ref('')
const logoSizeLimitExceed = ref(false)
const reasonDeletion = ref('')
const loading = ref(false)
const today = ref(new Date().toISOString().split('T')[0])
const valid = ref(false)
const dialog = ref(false)
const reason = ref(null)
const dateErrorMessage = ref('')

// Coupon reactive object
const coupon = ref<FullCoupon>({
  couponId: '',
  creationDate: '',
  startTime: '',
  endTime: '',
  usageLimit: 0,
  minPurchaseAmount: 0,
  discountType: '',
  status: '',
  isRecurring: false,
  recurringType: '',
  reason: '',
  parentCouponId: null,
  design: {
    title: '',
    description: '',
    disclaimer: '',
    listItems: [],
    media: {
      logo: '',
      couponImage: '',
      thumbnail: '',
    },
  },
  typography: {
    title: {
      fontWeight: '',
      fontSize: '',
      lineHeight: '',
      fontColor: '',
      textAlign: '',
      textDecoration: '',
      textTransform: '',
      descriptionfontWeight: '',
      descriptionfontSize: '',
      descriptionlineHeight: '',
      descriptionfontColor: '',
      descriptiontextAlign: '',
      descriptiontextDecoration: '',
      descriptiontextTransform: '',
      disclaimerfontWeight: '',
      disclaimerfontSize: '',
      disclaimerlineHeight: '',
      disclaimerfontColor: '',
      disclaimertextAlign: '',
      disclaimertextDecoration: '',
      disclaimertextTransform: '',
    },
  },
  callToAction: {
    text: '',
    link: '',
  },
  walletAppearance: {
    shortTitle: '',
    subheader: '',
    header: '',
    backgroundColor: '',
    fontColor: '',
    barcodeType: '',
    showCouponImageOn: [],
  },
  // Additional properties for UI state
  isDescriptionExpanded: false,
})

// Validation rules
const rules = {
  required: (v: any) => !!v || 'This field is required',
  maxLength: (max: number) => (v: string) =>
    !v || v.length <= max || `Maximum ${max} characters`,
  minLength: (min: number) => (v: string) =>
    !v || v.length >= min || `Minimum ${min} characters`,
  positiveNumber: (v: any) =>
    !v || Number(v) > 0 || 'Must be a positive number',
  futureDate: (v: string) =>
    !v || new Date(v) > new Date() || 'Date must be in the future',
  url: (v: string) =>
    !v ||
    /^(https?:\/\/.+|\/.*|#.*|mailto:|tel:)/.test(v) ||
    'Please enter a valid URL (absolute, relative, or protocol)',
}

// Snackbar
const snackbar = ref({
  visible: false,
  message: '',
})

// Delete dialog
const deleteDialog = ref({
  visible: false,
  couponId: '',
})

// Font properties
const fontProperties = ref({
  fontWeight: '',
  descriptionfontWeight: '',
  disclaimerfontWeight: '',
  textAlign: '',
  descriptiontextAlign: '',
  disclaimertextAlign: '',
  textTransform: '',
  descriptiontextTransform: '',
  disclaimertextTransform: '',
  textDecoration: '',
  descriptiontextDecoration: '',
  disclaimertextDecoration: '',
  fontSize: '',
  descriptionfontSize: '',
  disclaimerfontSize: '',
  lineHeight: '',
  descriptionlineHeight: '',
  disclaimerlineHeight: '',
  height: '',
  fontColor: '#000000',
  descriptionfontColor: '#000000',
  disclaimerfontColor: '#000000',
})

// Dynamic fields
const dynamicFields = ref([
  {
    column: 1,
    items: [''],
  },
])

// Static data
const recurringOption = ['Daily', 'Weekly', 'Monthly']

const fontWeights = ref([
  { text: 'Normal 400', value: 400 },
  { text: 'Bold 700', value: 700 },
])

const textAlignOptions = ref([
  { text: 'Left', value: 'left' },
  { text: 'Center', value: 'center' },
  { text: 'Right', value: 'right' },
  { text: 'Initial', value: 'initial' },
])

const textTransformOptions = ref([
  { text: 'None', value: 'none' },
  { text: 'Capitalize', value: 'capitalize' },
  { text: 'Lowercase', value: 'lowercase' },
  { text: 'Uppercase', value: 'uppercase' },
])

const textDecorationOptions = ref([
  { text: 'None', value: 'none' },
  { text: 'Underline', value: 'underline' },
  { text: 'Line Through', value: 'line-through' },
  { text: 'Overline', value: 'overline' },
])

const designOptions = ['Design 1', 'Design 2', 'Design 3']
const discountOptoins = ['none', 'percentage', 'fixed_amount', 'free_shipping']

const statusOptions = [
  { value: 'Draft', title: 'Draft' },
  { value: 'Archived', title: 'Archived' },
  { value: 'Paused', title: 'Paused' },
  { value: 'Schedule', title: 'Schedule' },
  { value: 'Active', title: 'Active' },
]

const tooltips = {
  Draft:
    'Refers to a COUPON that is in Draft mode and not active.The coupon must have been Active before being set this Status',
  Archived:
    'Refers to a COUPON that is Archived and no longer usable.The coupon must have been Active before being set this Status',
  Paused:
    'Refers to a COUPON that is Paused the Coupon temporarily.The coupon must have been Active before being set this Status',
  Schedule:
    'Set a DATE/TIME to today to change the STATUS of a COUPON to ACTIVE (Ensure the time is not in the past Time must be exact match or in future)',
  Active:
    'STATUS of a COUPON that is live on the site. Must have an EXPIRATION date in the future.And Start Date Not in future',
}

// Flatpickr config
const config = {
  enableTime: true,
  dateFormat: 'Y-m-d h:i K',
  minuteIncrement: 1,
  time_24hr: false,
  onReady(selectedDates: any, dateStr: string, instance: any) {
    const todayButton = document.createElement('button')
    todayButton.textContent = 'Today'
    todayButton.type = 'button'
    todayButton.className = 'flatpickr-today-button'
    todayButton.addEventListener('click', () => {
      const today = new Date()
      instance.setDate(today, true)
    })
    instance.calendarContainer.appendChild(todayButton)
  },
}

// Computed properties
const filteredStatusOptions = computed(() => {
  return statusOptions.filter(status => status.value !== coupon.value.status)
})

const openDeleteDialog = () => {
  deleteDialog.value.visible = true
  deleteDialog.value.couponId = selectedCouponId.value
}

const confirmDelete = async () => {
  try {
    await store.deleteCoupon(selectedCouponId.value)

    deleteDialog.value.visible = false
    emit('update:couponId', null)
  } catch (error: any) {
    snackbar.value.message = error?.response?.data?.message
    deleteDialog.value.visible = false

    console.error('Error deleting coupon:', error)
    throw error
  } finally {
    deleteDialog.value.visible = false
  }
}

const formatDateString = (dateString: string) => {
  const date = new Date(dateString)
  return date.toISOString().slice(0, 19)
}

const validateForm = () => {
  // Check Dropzone logo
  if (!coupon.value.design.media?.logo) {
    toast.error('Please upload a logo')
    return false
  }

  // Use Vuetify's built-in form validation
  const isValid = valid.value

  if (logoSizeLimitExceed.value) {
    return false
  }

  if (!isValid) {
    toast.error('Please fill all the required fields correctly')
  }

  return isValid
}

const updateCouponData = async () => {
  const couponId = selectedCouponId.value
  couponIdToShow.value = couponId

  if (couponId) {
    loading.value = true

    try {
      const fetchedCoupon = await store.getCouponDetails(couponId)
      console.log('#### fetchedCoupon', fetchedCoupon)

      if (fetchedCoupon) {
        originalCoupon.value = JSON.parse(JSON.stringify(fetchedCoupon))

        Object.assign(coupon.value, {
          couponId: fetchedCoupon?.couponId || '',
          creationDate: fetchedCoupon?.creationDate || '',
          startTime: fetchedCoupon?.startTime ?? '',
          endTime: fetchedCoupon?.endTime ?? '',
          usageLimit: fetchedCoupon?.usageLimit || 0,
          minPurchaseAmount: fetchedCoupon?.minPurchaseAmount || 0,
          discountType: fetchedCoupon?.discountType || '',
          status: fetchedCoupon?.status,
          isRecurring: fetchedCoupon?.isRecurring,
          recurringType: fetchedCoupon?.recurringType,
          parentCouponId: fetchedCoupon?.parentCouponId || null,
          reason: fetchedCoupon?.reason || '',
          design: {
            title: fetchedCoupon?.design?.title || '',
            description: fetchedCoupon?.design?.description || '',
            disclaimer: fetchedCoupon?.design?.disclaimer || '',
            listItems: fetchedCoupon?.design?.listItems || [],
            media: {
              logo: fetchedCoupon?.design?.media?.logo || '',
              thumbnail: fetchedCoupon?.design?.media?.thumbnail || '',
              couponImage: fetchedCoupon?.design?.media?.couponImage || '',
            },
          },
          typography: {
            title: {
              fontWeight: fetchedCoupon?.typography?.title?.fontWeight || '',
              fontSize: fetchedCoupon?.typography?.title?.fontSize || '',
              lineHeight: fetchedCoupon?.typography?.title?.lineHeight || '',
              fontColor: fetchedCoupon?.typography?.title?.fontColor || '',
              textAlign: fetchedCoupon?.typography?.title?.textAlign || '',
              textDecoration:
                fetchedCoupon?.typography?.title?.textDecoration || '',
              textTransform:
                fetchedCoupon?.typography?.title?.textTransform || '',
              descriptionfontWeight:
                fetchedCoupon?.typography?.title?.descriptionfontWeight || '',
              descriptionfontSize:
                fetchedCoupon?.typography?.title?.descriptionfontSize || '',
              descriptionlineHeight:
                fetchedCoupon?.typography?.title?.descriptionlineHeight || '',
              descriptionfontColor:
                fetchedCoupon?.typography?.title?.descriptionfontColor || '',
              descriptiontextAlign:
                fetchedCoupon?.typography?.title?.descriptiontextAlign || '',
              descriptiontextDecoration:
                fetchedCoupon?.typography?.title?.descriptiontextDecoration ||
                '',
              descriptiontextTransform:
                fetchedCoupon?.typography?.title?.descriptiontextTransform ||
                '',
              disclaimerfontWeight:
                fetchedCoupon?.typography?.title?.disclaimerfontWeight || '',
              disclaimerfontSize:
                fetchedCoupon?.typography?.title?.disclaimerfontSize || '',
              disclaimerlineHeight:
                fetchedCoupon?.typography?.title?.disclaimerlineHeight || '',
              disclaimerfontColor:
                fetchedCoupon?.typography?.title?.disclaimerfontColor || '',
              disclaimertextAlign:
                fetchedCoupon?.typography?.title?.disclaimertextAlign || '',
              disclaimertextDecoration:
                fetchedCoupon?.typography?.title?.disclaimertextDecoration ||
                '',
              disclaimertextTransform:
                fetchedCoupon?.typography?.title?.disclaimertextTransform || '',
            },
          },
          callToAction: {
            text: fetchedCoupon?.callToAction?.text || '',
            link: fetchedCoupon?.callToAction?.link || '',
          },
          walletAppearance: fetchedCoupon?.walletAppearance || {
            shortTitle: '',
            subheader: '',
            header: '',
            backgroundColor: '',
            fontColor: '',
            barcodeType: '',
            showCouponImageOn: [],
          },
        })

        console.log('COUPON VALUE', coupon.value)
        console.log('### fetchedCoupon?.startTime', fetchedCoupon?.startTime)
        console.log('### converted?.startTime', coupon.value.startTime)

        nextTick(() => {
          initializeDropzone(
            dropzoneLogo.value,
            coupon.value.design.media?.logo,
          )
          initializeDropzone(
            dropzoneCouponImage.value,
            coupon.value.design.media?.couponImage,
          )
          initializeDropzone(
            dropzoneThumbnail.value,
            coupon.value.design.media?.thumbnail,
          )
        })
      } else {
        console.log('Failed to fetch coupon details')
      }
    } catch (error) {
      console.error('Error fetching coupon details:', error)
    } finally {
      loading.value = false
    }
  } else {
    console.error('Coupon ID not found in URL')
  }
}

const initializeDropzone = (dropzoneElement: any, image: string = '') => {
  if (dropzoneElement == null) {
    return
  }

  // Destroy existing Dropzone instance if it exists
  if (dropzoneElement.dropzone) {
    dropzoneElement.dropzone.destroy()
  }

  // Ensure Dropzone does not auto-bind by class name elsewhere
  try {
    ;(Dropzone as any).autoDiscover = false
  } catch {}

  const dropzoneInstance = new Dropzone(dropzoneElement, {
    url: '/upload',
    autoProcessQueue: false,
    addRemoveLinks: true,
    clickable: true,
    thumbnailWidth: 100,
    thumbnailHeight: 100,
    acceptedFiles: 'image/*',
    previewsContainer: dropzoneElement,
    maxFilesize: 2,
    uploadMultiple: false,

    init: function () {
      if (image) {
        const mockFile = { name: 'mock_file', size: 12345 }
        this.emit('addedfile', mockFile)
        this.emit('thumbnail', mockFile, image)
        this.emit('complete', mockFile)
        // No-op: the general addedfile handler below will handle user uploads

        const img = new Image()
        img.src = image

        img.onload = function () {
          const aspectRatio = img.width / img.height

          const containerWidth = dropzoneElement.offsetWidth
          const containerHeight = dropzoneElement.offsetHeight

          let newWidth = containerWidth
          let newHeight = containerWidth / aspectRatio

          if (newHeight > containerHeight) {
            newHeight = containerHeight
            newWidth = containerHeight * aspectRatio
          }

          const thumbnail = dropzoneElement.querySelector('.dz-image')
          if (thumbnail) {
            thumbnail.style.width = `130px`
            thumbnail.style.display = 'flex'
          }
        }
      }

      this.on('addedfile', async (file: any) => {
        const base64Image = await fileToBase64(file)

        if (!coupon.value.design?.media) {
          coupon.value.design.media = {
            logo: '',
            couponImage: '',
            thumbnail: '',
          }
        }

        if (dropzoneElement === dropzoneLogo.value) {
          coupon.value.design.media.logo = base64Image
        } else if (dropzoneElement === dropzoneCouponImage.value) {
          coupon.value.design.media.couponImage = base64Image
        } else if (dropzoneElement === dropzoneThumbnail.value) {
          coupon.value.design.media.thumbnail = base64Image
        }
      })

      this.on('removedfile', (file: any) => {
        if (!coupon.value.design?.media) {
          coupon.value.design.media = {
            logo: '',
            couponImage: '',
            thumbnail: '',
          }
        }

        if (dropzoneElement === dropzoneLogo.value) {
          coupon.value.design.media.logo = ''
        } else if (dropzoneElement === dropzoneCouponImage.value) {
          coupon.value.design.media.couponImage = ''
        } else if (dropzoneElement === dropzoneThumbnail.value) {
          coupon.value.design.media.thumbnail = ''
        }
      })

      this.on('error', (file: any, message: string) => {
        if (message === 'File is too big') {
          toast.error('Logo must be under 2 MB')
          logoSizeLimitExceed.value = true
        }
      })
    },
  })

  // Store the dropzone instance on the element for future cleanup
  dropzoneElement.dropzone = dropzoneInstance
}

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

const isValidBase64Image = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false
  return str.startsWith('data:image/') && str.includes(';base64,')
}

const ensureBase64Format = (imageData: string = ''): string => {
  if (imageData === '') return ''

  // If it's already in the correct format, return as is
  if (isValidBase64Image(imageData)) {
    return imageData
  }

  // If it's a URL, we can't convert it to base64 here
  // Return empty string to avoid sending invalid data
  if (imageData.startsWith('http://') || imageData.startsWith('https://')) {
    console.warn('Image is a URL, cannot convert to base64:', imageData)
    return ''
  }

  // If it's just base64 data without the prefix, add the prefix
  if (imageData.match(/^[A-Za-z0-9+/]*={0,2}$/)) {
    console.warn(
      'Image data appears to be base64 without prefix, adding default prefix',
    )
    return `data:image/jpeg;base64,${imageData}`
  }

  return ''
}

const EndStatusChange = async () => {
  const today = new Date()

  const todayDate = new Date(today)
  const formattedToday = todayDate.toISOString().slice(0, 16)
  const endDate = new Date(coupon.value.endTime)
  const endDateformt = endDate.toISOString().slice(0, 16)
  console.log('formattedToday', formattedToday)
  console.log('endDate', endDate)
  console.log('endDateformt', endDateformt)
  if (coupon.value.status === 'Expired') {
    if (endDateformt > formattedToday) {
      coupon.value.status = 'Active'
      console.log('something happening here')
    }
  }
  if (coupon.value.status == 'Active') {
    if (endDateformt < formattedToday) {
      coupon.value.status = 'Expired'
      console.log('something happening here')
    }
  }
}

const StatusChange = async () => {
  // Only auto-switch if we're in Schedule/Active mode already
  if (!['Schedule', 'Active'].includes(coupon.value.status)) {
    return
  }

  const now = new Date()
  const start = new Date(coupon.value.startTime)

  if (start > now) {
    coupon.value.status = 'Schedule'
  } else {
    coupon.value.status = 'Active'
  }
}

const onStatusChange = () => {
  console.log('check status', coupon.value.status)
  if (coupon.value.status === 'Pending' || coupon.value.status === 'Archived') {
    dialog.value = true
  } else if (coupon.value.status === 'Draft') {
    reason.value = null
  }
}

const reasonDialog = () => {
  console.log('check status', coupon.value.status)
  dialog.value = true
}

const couponPayload = (): FullCoupon & { couponId: string } => {
  if (coupon.value.status === 'Resume') {
    coupon.value.status = 'Active'
  }

  const original = originalCoupon.value
  const current = coupon.value

  function toUTCISOString(localStr: string) {
    const localDate = new Date(localStr)
    return localDate.toISOString()
  }

  if (!original) {
    console.log('RETURN WITH CURRENT', current)
    // Return a complete payload with current values when original is null
    return current
  }

  const diffVal = (currentVal: any, originalVal: any) =>
    currentVal !== originalVal ? currentVal : originalVal

  return {
    creationDate: '',
    couponId: selectedCouponId.value,
    startTime: diffVal(current.startTime, original.startTime),
    endTime: diffVal(current.endTime, original.endTime),
    usageLimit: diffVal(
      Number(current.usageLimit) || 0,
      Number(original.usageLimit) || 0,
    ),
    minPurchaseAmount: diffVal(
      Number(current.minPurchaseAmount) || 0,
      Number(original.minPurchaseAmount) || 0,
    ),
    status: diffVal(current.status, original.status),
    reason: diffVal(current.reason, original.reason),
    discountType: diffVal(current.discountType, original.discountType),
    isRecurring: diffVal(current.isRecurring, original.isRecurring),
    recurringType: diffVal(current.recurringType, original.recurringType),
    parentCouponId: diffVal(current.parentCouponId, original.parentCouponId),
    design: {
      title: diffVal(current.design?.title, original.design?.title),
      description: diffVal(
        current.design?.description,
        original.design?.description,
      ),
      disclaimer: diffVal(
        current.design?.disclaimer,
        original.design?.disclaimer,
      ),
      listItems: diffVal(
        current.design?.listItems &&
          typeof current.design.listItems === 'string'
          ? (() => {
              try {
                return JSON.parse(current.design.listItems)
              } catch (e) {
                console.warn('Failed to parse listItems JSON:', e)
                return []
              }
            })()
          : [],
        original.design?.listItems,
      ),
      media: {
        logo: diffVal(
          ensureBase64Format(current.design?.media?.logo),
          original.design?.media?.logo,
        ),
        couponImage: diffVal(
          ensureBase64Format(current.design?.media?.couponImage),
          original.design?.media?.couponImage,
        ),
        thumbnail: diffVal(
          ensureBase64Format(current.design?.media?.thumbnail),
          original.design?.media?.thumbnail,
        ),
      },
    },
    typography: {
      title: {
        fontWeight: diffVal(
          current.typography?.title?.fontWeight,
          original.typography?.title?.fontWeight,
        ),
        fontSize: diffVal(
          Number(current.typography?.title?.fontSize) || 0,
          Number(original.typography?.title?.fontSize) || 0,
        ),
        lineHeight: diffVal(
          Number(current.typography?.title?.lineHeight) || 0,
          Number(original.typography?.title?.lineHeight) || 0,
        ),
        fontColor: diffVal(
          current.typography?.title?.fontColor,
          original.typography?.title?.fontColor,
        ),
        textAlign: diffVal(
          current.typography?.title?.textAlign,
          original.typography?.title?.textAlign,
        ),
        textDecoration: diffVal(
          current.typography?.title?.textDecoration,
          original.typography?.title?.textDecoration,
        ),
        textTransform: diffVal(
          current.typography?.title?.textTransform,
          original.typography?.title?.textTransform,
        ),
        // Description typography properties
        descriptionfontWeight: diffVal(
          current.typography?.title?.descriptionfontWeight,
          original.typography?.title?.descriptionfontWeight,
        ),
        descriptionfontSize: diffVal(
          Number(current.typography?.title?.descriptionfontSize) || 0,
          Number(original.typography?.title?.descriptionfontSize) || 0,
        ),
        descriptionlineHeight: diffVal(
          Number(current.typography?.title?.descriptionlineHeight) || 0,
          Number(original.typography?.title?.descriptionlineHeight) || 0,
        ),
        descriptionfontColor: diffVal(
          current.typography?.title?.descriptionfontColor,
          original.typography?.title?.descriptionfontColor,
        ),
        descriptiontextAlign: diffVal(
          current.typography?.title?.descriptiontextAlign,
          original.typography?.title?.descriptiontextAlign,
        ),
        descriptiontextDecoration: diffVal(
          current.typography?.title?.descriptiontextDecoration,
          original.typography?.title?.descriptiontextDecoration,
        ),
        descriptiontextTransform: diffVal(
          current.typography?.title?.descriptiontextTransform,
          original.typography?.title?.descriptiontextTransform,
        ),
        // Disclaimer typography properties
        disclaimerfontWeight: diffVal(
          current.typography?.title?.disclaimerfontWeight,
          original.typography?.title?.disclaimerfontWeight,
        ),
        disclaimerfontSize: diffVal(
          Number(current.typography?.title?.disclaimerfontSize) || 0,
          Number(original.typography?.title?.disclaimerfontSize) || 0,
        ),
        disclaimerlineHeight: diffVal(
          Number(current.typography?.title?.disclaimerlineHeight) || 0,
          Number(original.typography?.title?.disclaimerlineHeight) || 0,
        ),
        disclaimerfontColor: diffVal(
          current.typography?.title?.disclaimerfontColor,
          original.typography?.title?.disclaimerfontColor,
        ),
        disclaimertextAlign: diffVal(
          current.typography?.title?.disclaimertextAlign,
          original.typography?.title?.disclaimertextAlign,
        ),
        disclaimertextDecoration: diffVal(
          current.typography?.title?.disclaimertextDecoration,
          original.typography?.title?.disclaimertextDecoration,
        ),
        disclaimertextTransform: diffVal(
          current.typography?.title?.disclaimertextTransform,
          original.typography?.title?.disclaimertextTransform,
        ),
      },
    },
    callToAction: {
      text: diffVal(current.callToAction?.text, original.callToAction?.text),
      link: diffVal(current.callToAction?.link, original.callToAction?.link),
    },
    walletAppearance: {
      shortTitle: original.walletAppearance?.shortTitle || '',
      subheader: original.walletAppearance?.subheader || '',
      header: original.walletAppearance?.header || '',
      backgroundColor: original.walletAppearance?.backgroundColor || '',
      fontColor: original.walletAppearance?.fontColor || '',
      barcodeType: original.walletAppearance?.barcodeType || '',
      showCouponImageOn: original.walletAppearance?.showCouponImageOn || [],
    },
  }
}

const Style = (coupon: any) => {
  return {
    color: coupon?.typography?.title?.fontColor,
    fontSize: `${coupon?.typography?.title?.fontSize}px`,
    fontWeight: coupon?.typography?.title?.fontWeight,
    textAlign: coupon?.typography?.title?.textAlign,
    textTransform: coupon?.typography?.title?.textTransform,
    textDecoration: coupon?.typography?.title?.textDecoration,
    lineHeight: `${coupon?.typography?.title?.lineHeight}em`,
  }
}

const disclaimerStyle = (coupon: any) => {
  return {
    color: coupon?.typography?.title?.disclaimerfontColor,
    fontSize: `${coupon?.typography?.title?.disclaimerfontSize}px`,
    fontWeight: coupon?.typography?.title?.disclaimerfontWeight,
    textAlign: coupon?.typography?.title?.disclaimertextAlign,
    textTransform: coupon?.typography?.title?.disclaimertextTransform,
    textDecoration: coupon?.typography?.title?.disclaimertextDecoration,
    lineHeight: `${coupon?.typography?.title?.disclaimerlineHeight}em`,
  }
}

const descriptionStyle = (coupon: any) => {
  return {
    color: coupon?.typography?.title?.descriptionfontColor,
    fontSize: `${coupon?.typography?.title?.descriptionfontSize}px`,
    fontWeight: coupon?.typography?.title?.descriptionfontWeight,
    textAlign: coupon?.typography?.title?.descriptiontextAlign,
    textTransform: coupon?.typography?.title?.descriptiontextTransform,
    textDecoration: coupon?.typography?.title?.descriptiontextDecoration,
    lineHeight: `${coupon?.typography?.title?.descriptionlineHeight}em`,
  }
}

const updateCoupon = async () => {
  loading.value = true
  const payload = couponPayload()
  console.log('👉 payload.status =', payload.status)

  // Check if payload is valid (not empty object)
  if (!payload || Object.keys(payload).length === 0) {
    toast.error('Unable to update coupon: No original data found')
    loading.value = false
    return
  }

  if (validateForm()) {
    try {
      const newVal = coupon.value.status
      const oldVal = (coupon.value as any).previousStatus || null

      console.log('check the new val', newVal)

      const startDate = new Date(coupon.value.startTime)
      const today = new Date()
      const todayInNY = new Date(today)

      if (startDate > today) {
        console.log(startDate)
        console.log(today)
        console.log('Hello')
      }
      if (newVal === 'Active') {
        if (startDate > today) {
          toast.error(
            `Cannot set Active status for a coupon starting in the future. Current Start Date is ${startDate.toLocaleString()}`,
          )
          loading.value = false
          return
        }
      } else if (newVal === 'Schedule') {
        const startDateObj = new Date(startDate)
        const todayObj = new Date(today)

        if (startDate <= today) {
          toast.error(
            `Before Schedule ensure that the date is in the future. Current Start Date is ${startDateObj.toLocaleString()}`,
          )
          loading.value = false
          return
        }
      } else if (newVal === 'Draft') {
        coupon.value.status = newVal
      }

      // Convert startTime and endTime to server time before saving
      if (payload.startTime) {
        payload.startTime = convertLocalTimeToServerTime(payload.startTime)
      }
      if (payload.endTime) {
        payload.endTime = convertLocalTimeToServerTime(payload.endTime)
      }

      await store.updateCoupon(payload)
      loading.value = false

      nextTick(() => {
        initializeDropzone(dropzoneLogo.value, coupon.value.design.media?.logo)
        initializeDropzone(
          dropzoneCouponImage.value,
          coupon.value.design.media?.couponImage,
        )
        initializeDropzone(
          dropzoneThumbnail.value,
          coupon.value.design.media?.thumbnail,
        )

        emit('update:couponId', null)
      })
    } catch (error: any) {
      snackbar.value.visible = true
      snackbar.value.message = 'Not update Successfully an error Occured! here.'
      console.error('Error updating coupon:', error)
    }
  }

  loading.value = false
}

const calculateExpirationInfo = (endStr: string) => {
  const endDate = new Date(endStr)
  const now = new Date()
  const diffMs = endDate.getTime() - now.getTime()

  if (diffMs <= 0) {
    return 'Expired'
  }

  const msInHour = 1000 * 60 * 60
  const msInDay = msInHour * 24

  const days = Math.floor(diffMs / msInDay)
  const hours = Math.floor((diffMs % msInDay) / msInHour)
  const minutes = Math.floor((diffMs % msInHour) / (1000 * 60))

  if (days >= 1) {
    return days === 1 ? 'Tomorrow' : `${days} days left`
  }
  return `${hours} hour(s) and ${minutes} minute(s) Left`
}

const cancel = () => {
  emit('update:couponId', null)
}

const handleClickDatePicker = (e: Event) => {
  const target = e.target as HTMLInputElement
  target.showPicker()
}

const updateFields = () => {
  // Implementation would depend on selectedColumns variable
  // This was referenced but not defined in the original code
}

const addField = () => {
  const columnNumber = dynamicFields.value.length + 1
  dynamicFields.value.push({
    column: columnNumber,
    items: [''],
  })
}

const removeField = () => {
  if (dynamicFields.value.length > 0) {
    dynamicFields.value.pop()
  }
}

// Watchers
watch(
  () => props.couponId,
  () => {
    updateCouponData()
  },
  { immediate: true },
)

watch(
  () => coupon.value.startTime,
  (newValue, oldValue) => {
    const normalizeDate = (date: string) => {
      if (!date) return null
      const parsedDate = new Date(date)
      return isNaN(parsedDate.getTime())
        ? date
        : parsedDate.toISOString().slice(0, 16)
    }

    const normalizedNewValue = normalizeDate(newValue)
    const normalizedOldValue = normalizeDate(oldValue)

    if (normalizedNewValue !== normalizedOldValue) {
      StatusChange()
    }
  },
)

watch(
  () => coupon.value.endTime,
  (newValue, oldValue) => {
    const normalizeDate = (date: string) => {
      if (!date) return null
      const parsedDate = new Date(date)
      return isNaN(parsedDate.getTime())
        ? date
        : parsedDate.toISOString().slice(0, 16)
    }

    const normalizedNewValue = normalizeDate(newValue)
    const normalizedOldValue = normalizeDate(oldValue)

    if (normalizedNewValue !== normalizedOldValue) {
      EndStatusChange()
      calculateExpirationInfo(coupon.value.endTime)
    }
  },
)

let isFirstLoad = true
watch(
  () => coupon.value.status,
  (newVal, oldVal) => {
    if (isFirstLoad) {
      isFirstLoad = false
      return
    }

    if (
      newVal === 'Archived' ||
      newVal === 'Draft' ||
      (newVal === 'Paused' && newVal !== oldVal)
    ) {
      reasonDialog()
    }
  },
)

// Cleanup function to destroy Dropzone instances
const cleanupDropZones = () => {
  const dropzoneElements = [
    dropzoneLogo.value,
    dropzoneCouponImage.value,
    dropzoneThumbnail.value,
  ]

  dropzoneElements.forEach(element => {
    if (element && (element as any).dropzone) {
      ;(element as any).dropzone.destroy()
      ;(element as any).dropzone = null
    }
  })
}

// Cleanup on component unmount
onUnmounted(() => {
  cleanupDropZones()
})
</script>

<style scoped>
:deep(.v-label.v-field-label) {
  margin-left: 12px !important;
}

:deep(.v-select .v-field .v-field__input > input) {
  background: none;
  border: none;
  box-shadow: none;
}

:deep(.v-field__input) {
  background: none;
  border: none;
}

:deep(.v-field--variant-outlined .v-field__input) {
  padding: 12px 16px;
}

:deep(.v-field--variant-filled .v-field__input) {
  box-shadow: none;
  line-height: 1.625em;
  padding: 24px 16px 4px 16px;
}

#coupon-builder-admin
  :deep(
    .v-field.v-field--variant-outlined .v-field__field input[type='text']:focus
  ) {
  box-shadow: none !important;
}

#coupon-builder-admin
  :deep(
    .v-field.v-field--variant-outlined
      .v-field__field
      input[type='number']:focus
  ) {
  box-shadow: none !important;
}

@media (max-width: 425px) {
  :deep(.v-expansion-panel-text__wrapper) {
    padding-left: 10px;
    padding-right: 10px;
  }

  :deep(.v-card-text) {
    padding-left: 5px;
    padding-right: 5px;
  }

  :deep(.v-field__input) {
    padding: 10px !important;
  }

  #coupon-builder-admin
    :deep(
      .v-expansion-panel-text.filters-section
        .v-expansion-panel-text__wrapper
        > div
    ) {
    margin: 0;
  }
}

.auto-width {
  width: auto;
}

.v-progress-circular {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

@media (min-width: 600px) and (max-width: 1286px) {
  .updated-content {
    max-width: 100%;
  }
}

.datepicker-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.custom-datepicker {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f9f9f9;
  color: #1b1a1a;
  font-size: larger;
  border-bottom: 1px solid;
  border-radius: none;
  border-radius: 0;
}

.pad-to-add-coup {
  padding: 10px !important;
}

.custom-datepicker::placeholder {
  color: #aaa;
}

.calendar-icon {
  position: absolute;
  right: 10px;
  /* color: #aaa; */
  pointer-events: none;
}

input.custom-datepicker.flatpickr-input::placeholder {
  color: black;
}

.dropdown-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.styled-dropdown {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px;
  background-color: #fff;
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */
}

.dropdown-item {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.v-select-menu {
  max-height: 300px;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

label span {
  color: red;
}

.dz-image {
  min-width: 200px !important;
  min-height: 200px !important;
}

.error-message {
  color: #a21d1d;
  margin-top: 0.25rem;
  margin-left: 10px;
  font-size: 13px;
}

.updated-content {
  max-width: 100%;
}

.coupon-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  background-color: #ffffff;
  transition: transform 0.3s ease;
  margin-bottom: 20px;
  overflow: hidden;
}

.coupon-card:hover {
  transform: translateY(-5px);
}

.v-card {
  padding: 16px;
}

.text-center {
  text-align: center;
}

.grey--text {
  background: #f3f5f7;
  color: rgb(30, 0, 0);
  padding: 3px 5px;
  border-radius: 5px;
}

.custom-divider {
  height: 3px;
  background-color: #000;
}

.v-divider {
  height: 8px !important;
  background: #545151;
  max-height: none;
  width: 70%;
  margin-left: 65px;
  opacity: unset;
}

.v-img__img {
  width: -webkit-fill-available !important;
  height: auto !important;
}

.v-img {
  height: fit-content !important;
}

.download-btn {
  margin-top: 5px;
  /* float: right; */
}

.exp-info {
  font-weight: bold;
}

.v-progress-circular {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.color-field {
  color: gray;
  font-weight: 600;
}

.style-div-button {
  display: flex;
  justify-content: end;
  gap: 10px;
  flex-wrap: wrap;
}

.sticky-preview {
  position: sticky;
  top: 0;
  max-height: calc(100vh - 30px);
  /* Viewport height minus offset */
  overflow-y: auto;
}

.title-text {
  /* allow wrapping even without spaces */
  overflow-wrap: break-word;
  word-break: break-all;

  /* ensure it can break onto multiple lines */
  white-space: normal;
}

@media only screen and (max-width: 900px) {
  .custom-class {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .sticky-preview {
    position: static;
    top: 50px;
    max-height: calc(100vh - 30px);
    /* Viewport height minus offset */
    overflow-y: auto;
  }

  .pad-to-add-coup {
    padding: 0px !important;
  }

  .datepicker-wrapper {
    display: none;
  }
}

.edit-coupon-div {
  background-color: rgb(239, 239, 239);
  border-radius: 0px;
}

@media (min-width: 901px) {
  .mobile-only {
    display: none !important;
  }
}
</style>
